import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import Cookies from "js-cookie";
import { login } from "../pages/auth/api";

interface AuthState {
  isLoggedin: boolean;
  token: string | null;
  loading: boolean;
  errorMessage: string | null;
}


const initialState: AuthState = {
  isLoggedin: false,
  token: Cookies.get("loginToken") || null,
  loading: false,
  errorMessage: null,
};



export const authenticateWithCredentials = createAsyncThunk(
  "auth/loginWithCredentials",
  async ({ email, password }: { email: string; password: string }) => {
    try {
      const response = await login({ email, password });
      localStorage.setItem("first_name", response.data.admindata.first_name);
      localStorage.setItem("last_name", response.data.admindata.last_name);
       localStorage.setItem("email", response.data.admindata.email);
      Cookies.set("loginToken", response.data.token);
      console.log("response", response);
      return response.data;
    } catch (error: any) {
      console.log("error", error);
      throw new Error(error.response.data.error || "something went wrong");
    }
  }
);

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(authenticateWithCredentials.pending, (state: AuthState) => {
      state.loading = true;
    });
    builder.addCase(
      authenticateWithCredentials.fulfilled,
      (state: AuthState, action: PayloadAction<AuthState>) => {
        state.loading = false;
        const { payload } = action;
        state.isLoggedin = true;
        state.token = payload.token;
        state.errorMessage = null;
      }
    );
    builder.addCase(
      authenticateWithCredentials.rejected,
      (state: AuthState, action: PayloadAction<unknown>) => {
        state.loading = false;
        state.isLoggedin = false;
        state.token = null;
        state.errorMessage = action.payload as string;
      }
    );
  },
});

export const selectAuthStateCredentials = (state: { auth: AuthState }) =>
  state.auth;

export const authReducerCredentials = authSlice.reducer;
